'use client';
import React from 'react';
import { ResponsiveContainer, LineChart, Line } from 'recharts';

interface EntitySparklineProps {
  data: number[];
  positive: boolean;
}

export default function EntitySparkline({ data, positive }: EntitySparklineProps) {
  const chartData = data.map((v, i) => ({ i, v }));
  return (
    <ResponsiveContainer data-component-id="src/app/components/EntitySparkline.tsx:13:4" data-component-path="src/app/components/EntitySparkline.tsx" data-component-line="13" data-component-end-line="23" data-component-file="EntitySparkline.tsx" data-component-name="ResponsiveContainer" data-component-content="%7B%22elementName%22%3A%22ResponsiveContainer%22%7D" width="100%" height="100%">
      <LineChart data-component-id="src/app/components/EntitySparkline.tsx:14:6" data-component-path="src/app/components/EntitySparkline.tsx" data-component-line="14" data-component-end-line="22" data-component-file="EntitySparkline.tsx" data-component-name="LineChart" data-component-content="%7B%22elementName%22%3A%22LineChart%22%7D" data={chartData}>
        <Line data-component-id="src/app/components/EntitySparkline.tsx:15:8" data-component-path="src/app/components/EntitySparkline.tsx" data-component-line="15" data-component-end-line="21" data-component-file="EntitySparkline.tsx" data-component-name="Line" data-component-content="%7B%22elementName%22%3A%22Line%22%2C%22type%22%3A%22monotone%22%7D"
          type="monotone"
          dataKey="v"
          stroke={positive ? 'var(--positive)' : 'var(--negative)'}
          strokeWidth={1.5}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}